import { useEffect, useState } from "react";
import { ChevronLeft } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

let optionsCache = null;
const loadOptions = async () => (optionsCache ||= (await api.get("/landmarks/suggest")).data);

// Two-level event picker: category, then a specific holiday / person / free text (or none)
export const EventPicker = ({ onPick, testid = "event-picker" }) => {
  const { user } = useAuth();
  const [opts, setOpts] = useState(null);
  const [cat, setCat] = useState(null);
  const [people, setPeople] = useState([]);
  const [text, setText] = useState("");
  useEffect(() => { loadOptions().then(setOpts); }, []);
  useEffect(() => {
    if (cat === "Birthdays" && user?.role === "admin") api.get("/people").then((r) => setPeople(r.data.people.filter((p) => p.month)));
  }, [cat, user]);
  if (!opts) return <div className="lb-menu-empty">Loading…</div>;
  if (!cat) {
    return (
      <div className="event-list" data-testid={`${testid}-categories`}>
        {opts.categories.map((c) => <button type="button" key={c} onClick={() => { setCat(c); setText(""); }} data-testid={`${testid}-cat-${c.replace(/\W+/g, "-").toLowerCase()}`}>{c}</button>)}
      </div>
    );
  }
  const specifics = opts.category_events[cat];
  return (
    <div className="event-list" data-testid={`${testid}-specific`}>
      <button type="button" className="!text-neutral-500 inline-flex items-center gap-1" onClick={() => setCat(null)} data-testid={`${testid}-back`}><ChevronLeft size={14} /> {cat}</button>
      {cat === "Birthdays" ? (
        <>
          <button type="button" onClick={() => onPick(cat, "Birthday")} data-testid={`${testid}-birthday-plain`}>Just mark as a birthday</button>
          {people.map((p) => <button type="button" key={p.id} onClick={() => onPick(cat, "Birthday", p)} data-testid={`${testid}-person-${p.id}`}>Add to {p.name}'s Birthday Book</button>)}
        </>
      ) : specifics && cat !== "New Year Events" ? (
        <>
          {specifics.map((e) => <button type="button" key={e} onClick={() => onPick(cat, e)} data-testid={`${testid}-event-${e.replace(/\W+/g, "-").toLowerCase()}`}>{e}</button>)}
          <button type="button" onClick={() => onPick(cat, null)} data-testid={`${testid}-no-specific`}>No specific {cat === "Religious Holidays" ? "holiday" : "event"}</button>
        </>
      ) : (
        <form className="flex gap-2 p-1" onSubmit={(e) => { e.preventDefault(); onPick(cat, text.trim() || (specifics ? specifics[0] : null)); }}>
          <input className="login-input !mb-0 !py-1.5 flex-1" autoFocus placeholder="Specific name (optional), e.g. Mardi Gras" value={text} onChange={(e) => setText(e.target.value)} maxLength={40} data-testid={`${testid}-text`} />
          <button className="btn-ink !px-3 !py-1.5 text-sm" data-testid={`${testid}-save`}>Set</button>
        </form>
      )}
    </div>
  );
};

export const applyEvent = async (ids, category, event, person) => {
  const { data } = ids.length === 1
    ? { data: { done: 1, item: (await api.patch(`/items/${ids[0]}`, { event_category: category, event: event || "" })).data } }
    : await api.post("/items/bulk-event", { ids, category, event });
  if (person) await api.post(`/people/${person.id}/items`, { item_ids: ids });
  return data;
};
